/**
 * Aviso de versão nova.
 *
 * O app é uma PWA com precache: depois de um deploy, a aba que já estava
 * aberta continua rodando o código ANTIGO até um reload. Isso mordeu em sala
 * (03/08): o quiz tinha sido gravado no banco, mas a tela de resultados era a
 * versão anterior e não mostrava a seção — dava a impressão de que a resposta
 * do aluno tinha se perdido.
 *
 * O service worker é gerado com `skipWaiting` + `clientsClaim`, então a versão
 * nova assume o controle sozinha; o que faltava era avisar a aba aberta.
 *
 * NÃO recarrega sozinho de propósito: um reload no meio de uma aula, com o
 * vídeo tocando no telão, é pior que a tela desatualizada. O professor decide
 * quando — um toque no aviso.
 */
import { toast } from 'sonner';

export function observarVersaoNova() {
  if (!('serviceWorker' in navigator)) return;

  let avisado = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Primeiro registro do SW (instalação inicial) também dispara aqui, e aí
    // não há versão velha rodando — nada a avisar.
    if (avisado || !navigator.serviceWorker.controller) return;
    avisado = true;

    toast('Nova versão disponível', {
      description: 'Recarregue para ver as mudanças mais recentes.',
      duration: Infinity,
      action: {
        label: 'Atualizar',
        onClick: () => window.location.reload(),
      },
    });
  });
}
